import { SexEnum, PartnersRangeEnum, SexBarrierEnum } from "../../Types/Enums/SexEnum";

export const SEX_CONFIG = [
  { id: SexEnum.MALE, labels: { 0: "Masculino", 1: "Male" } },
  { id: SexEnum.FEMALE, labels: { 0: "Femenino", 1: "Female" } },
];

export const SEX_BARRIER_MAP = [
  { id: SexBarrierEnum.ALWAYS, labels: { 0: "Siempre", 1: "Always" } },
  { id: SexBarrierEnum.NEVER, labels: { 0: "Nunca", 1: "Never" } },
  { id: SexBarrierEnum.SOMETIMES, labels: { 0: "En Ocasiones", 1: "Sometimes" } },
]

export const PARTNERS_RANGE_MAP = [
  { id: PartnersRangeEnum.ZERO, labels: { 0: "0", 1: "0" } },
  { id: PartnersRangeEnum.ONE, labels: { 0: "1", 1: "1" } },
  { id: PartnersRangeEnum.TWO_FIVE, labels: { 0: "2-5", 1: "2-5" } },
  { id: PartnersRangeEnum.SIX_TEN, labels: { 0: "6-10", 1: "6-10" } },
  { id: PartnersRangeEnum.ABOVE_TEN, labels: { 0: "+10", 1: "+10" } },
]
